module.exports = __webpack_public_path__ + "js-technologies-color.2kq4xihT.svg";